import React, { useState } from 'react';
import { ApIcon, colors } from '@alixpartners/ui-components';
import { FilterOptions } from 'components/FilterOptions';
import {
	Wrapper,
	DropdownLabel,
	LabelText,
	StyledMenu,
	IconWrapper,
} from './FilterDropdown.styles';

const ALL_LABEL = 'All';
const NO_DATA_LABEL = 'No Data';
const LOADING_LABEL = 'Loading...';

export const FilterDropdown = ({ options, onChange, selected, isLoading }) => {
	const [isOpen, setOpen] = useState(false);

	const toggleMenu = open => {
		setOpen(open);
	};

	const handleChange = items => {
		onChange(items);
		toggleMenu(false);
	};

	const isDisabled = isLoading || !options || options.length === 0;
	const activeLabel = isLoading
		? LOADING_LABEL
		: isDisabled
			? NO_DATA_LABEL
			: selected && selected.length > 0
				? selected.join(', ')
				: ALL_LABEL;

	return (
		<StyledMenu
			button={
				<div style={isDisabled ? { pointerEvents: 'none' } : {}}>
					<DropdownLabel isOpen={isOpen} disabled={isDisabled}>
						<LabelText disabled={isDisabled}>{activeLabel}</LabelText>
						{!isDisabled && (
							<IconWrapper>
								<ApIcon iconName="caret" iconColor={colors.grey8} />
							</IconWrapper>
						)}
					</DropdownLabel>
				</div>
			}
			placement="bottom-start"
			toggleMenu={toggleMenu}
			isOpen={isOpen}
		>
			<Wrapper>
				<FilterOptions
					options={options}
					onCancel={() => {
						toggleMenu(false);
					}}
					onChange={handleChange}
					selected={selected}
				/>
			</Wrapper>
		</StyledMenu>
	);
};

export default FilterDropdown;
